import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";

// ------------------ FONT AWESOME -----------------------------------------------
import {
  library
} from "@fortawesome/fontawesome-svg-core";
import {
  FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";
// ------- Brands ----------------------------------------------------------------------------
import {
  faFontAwesome,
  faLinkedin,
  faSalesforce,
  faGithub,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";
library.add(faFontAwesome, faLinkedin, faSalesforce, faGithub, faTwitterSquare);
// ------- Solid -------------------------------------------------------------------------------
import {
  faEnvelope,
  faArrowRight,
  faCircle,
  faFilePdf,
  faTools,
  faBars,
  faArrowAltCircleDown
} from "@fortawesome/free-solid-svg-icons";
library.add(faBars, faEnvelope, faArrowRight, faCircle, faFilePdf, faTools, faArrowAltCircleDown);
//------ component ----------------------------------------------------------------------------
Vue.component("faw-icon", FontAwesomeIcon);
// -------------------- DIRECTIVES------------------------------------------------------------
let handleOutsideClick

Vue.directive('closable', {
  bind(el, binding, vnode) {
    // Here's the click/touchstart handler (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const {
        handler,
        exclude
      } = binding.value
      // if the clicked element is excluded
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        // haven't detected any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName]
          //if excluded element is the same element the user clicked on
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      // if the clicked element is not the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

// ------------------------------------

Vue.config.productionTip = false;


new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");